import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdatePaymentAccountsRequestModel, UpdatePaymentAccountsResponseModel } from "@/features/accounts/payment/scraping/services/update-accounts-model";

export class UpdatePaymentAccountsApi {
  /**
   * MoneyLook 口座情報更新API
   */
  public updatePaymentAccounts = async (
    param: UpdatePaymentAccountsRequestModel
  ): Promise<UpdatePaymentAccountsResponseModel> => {
    const path = `/api/paymentaccounts/payments`;
    const res = await ApiClient.instance.put<UpdatePaymentAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
